import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-6" }
const _hoisted_3 = { class: "col-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OrderInfoItemWrapperComponent = _resolveComponent("OrderInfoItemWrapperComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_OrderInfoItemWrapperComponent, {
          "data-class-name": '__data-1',
          "translate-key": 'pickup_place',
          class: "col-12"
        }, {
          "icon-item": _withCtx(() => _cache[2] || (_cache[2] = [
            _createElementVNode("img", {
              src: "/assets/images/Framelocation-icon.png",
              alt: "location"
            }, null, -1)
          ])),
          "order-info": _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.orderData.customRoutes[0].routePoint.raw.name) + ", " + _toDisplayString(_ctx.orderData.customRoutes[0].routePoint.raw.formatted_address), 1)
          ]),
          _: 1
        }),
        (_ctx.wayPoints.length)
          ? (_openBlock(), _createBlock(_component_OrderInfoItemWrapperComponent, {
              key: 0,
              "data-class-name": '__data-3',
              "translate-key": 'stops',
              class: "col-12"
            }, {
              "icon-item": _withCtx(() => [
                _withDirectives(_createElementVNode("div", null, [
                  _createElementVNode("img", {
                    id: "open-dropoffs",
                    src: "/assets/images/plus-circle-plus-svg.svg",
                    alt: "end-date-time",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDropOffs()))
                  })
                ], 512), [
                  [_vShow, !_ctx.open]
                ]),
                _withDirectives(_createElementVNode("div", null, [
                  _createElementVNode("img", {
                    id: "open-dropoffs-blue",
                    src: "/assets/images/plus-circle-plus-svg-blue.svg",
                    alt: "end-date-time",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDropOffs()))
                  })
                ], 512), [
                  [_vShow, _ctx.open]
                ])
              ]),
              "order-info": _withCtx(() => [
                (_ctx.open)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.wayPoints, (point) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: point.id,
                        class: "mb-2"
                      }, _toDisplayString(point.routePoint.raw.name) + ", " + _toDisplayString(point.routePoint.raw.formatted_address) + " - " + _toDisplayString(point.arrivalTime), 1))
                    }), 128))
                  : _createCommentVNode("", true),
                (!_ctx.open)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.wayPoints.length), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_OrderInfoItemWrapperComponent, {
          "data-class-name": '__data-5',
          "translate-key": 'final_destination',
          class: "col-12"
        }, {
          "icon-item": _withCtx(() => _cache[3] || (_cache[3] = [
            _createElementVNode("img", {
              src: "/assets/images/Framedestination.png",
              alt: "end-date-time"
            }, null, -1)
          ])),
          "order-info": _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.orderData.customRoutes[[_ctx.orderData.customRoutes.length - 1]].routePoint.raw.name) + ", " + _toDisplayString(_ctx.orderData.customRoutes[[_ctx.orderData.customRoutes.length - 1]].routePoint.raw.formatted_address), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_OrderInfoItemWrapperComponent, {
          "data-class-name": '__data-2',
          "translate-key": 'departure',
          class: "col-12"
        }, {
          "icon-item": _withCtx(() => _cache[4] || (_cache[4] = [
            _createElementVNode("img", {
              src: "/assets/images/Framecalendar-icon.png",
              alt: "pickup-date-time"
            }, null, -1)
          ])),
          "order-info": _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.orderData.customRoutes[0].arrivalDate) + " " + _toDisplayString(_ctx.orderData.customRoutes[0].arrivalTime), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_OrderInfoItemWrapperComponent, {
          "data-class-name": '__data-4',
          "translate-key": 'arrival',
          class: "col-12"
        }, {
          "icon-item": _withCtx(() => _cache[5] || (_cache[5] = [
            _createElementVNode("img", {
              src: "/assets/images/Framecalendar-icon.png",
              alt: "end-date-time"
            }, null, -1)
          ])),
          "order-info": _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.orderData.customRoutes[_ctx.orderData.customRoutes.length - 1].arrivalDate) + " " + _toDisplayString(_ctx.orderData.customRoutes[_ctx.orderData.customRoutes.length - 1].arrivalTime), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_OrderInfoItemWrapperComponent, {
          "data-class-name": '__data-6',
          "translate-key": 'passengers',
          class: "col-12"
        }, {
          "icon-item": _withCtx(() => _cache[6] || (_cache[6] = [
            _createElementVNode("img", {
              src: "/assets/images/Framepeople-icon.png",
              alt: "people-count"
            }, null, -1)
          ])),
          "order-info": _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.orderData.passengerCount), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col-sm-12 col-md-12 col-lg-11 hr-line" }, null, -1))
  ], 64))
}